import { useInfiniteQuery } from '@tanstack/react-query';

import { RoomListSortType } from '@/lib/coloc-api/admin';
import { useDebounce } from '@/hooks/use-debounce';
import { useColocApi } from '@/hooks/use-coloc-api';
import { getRoomList } from '@/services/coloc-api/admin';

const useGetRoomsInfinite = (params: { searchQuery?: string }) => {
  const { setPage, setPageLimit, page, pageLimit } =
    useColocApi<RoomListSortType>()!;
  const debouncedSearchQuery: string = useDebounce(
    params.searchQuery ?? '',
    500
  );

  const fetch = useInfiniteQuery({
    queryKey: ['getRoomList', debouncedSearchQuery, page, pageLimit],
    queryFn: ({ pageParam = 1 }) =>
      getRoomList({
        page_limit: 5,
        sort: 'name',
        with_owner: true,
        ...(pageParam && { page: pageParam }),
        ...(debouncedSearchQuery &&
          debouncedSearchQuery !== '' && { query: debouncedSearchQuery }),
      }),
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.pagination.total_pages > pages.length) {
        return pages.length + 1;
      }

      return undefined;
    },
  });

  return {
    pageLimit,
    setPageLimit,
    fetch,
    setPage,
  };
};

export { useGetRoomsInfinite };
